<script setup lang="ts">
/**
 * @author Alexander Kenchoshvili
 */

import Offer from "./parts/Offer.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import { swiperOptions } from "./ts/swiper";
import "swiper/css";

import { reqAxios } from "@/composables/core/func";
import { asignRoute } from "@/composables/utils/asignRoute";
import { useMyComposable } from "@/composables/core/conf";

import { getTaxonomySS } from "@/composables/core/func";

import { useBuildingStore } from "@/store/building/index";
import { onBeforeMount, computed, ref } from "vue";
import type { Flat } from "@/store/building/types/StateType";
import { SecondaryDataInterface } from "@/types/ContentType";

const router = useRouter();

defineProps<{
  contentData: SecondaryDataInterface;
}>();

await getTaxonomySS("flat_type");

const flatsList = ref<Flat[]>();

const buildingStore = useBuildingStore();

const conf = useMyComposable();

const { data: flatsRes } = await useFetch(conf.apiUrl + "development/getFlats", {
  method: "POST",
  body: {
    project_id: buildingStore?.selectedProject?.id,
    offer_price: 1,
  },
});

const { data: typesRes } = await useFetch(conf.apiUrl + "development/getTypes", {
  method: "POST",
  body: {
    projects: {
      id: buildingStore?.selectedProject?.id,
    },
    limit: 1000,
  },
});

onBeforeMount(async () => {
  const routeParams = router?.currentRoute?.value?.params?.slugs;

  setTimeout(async () => {
    // const flatsRes = await reqAxios("development/getFlats", {
    //   project_id: buildingStore?.selectedProject?.id,
    //   offer_price: 1,
    // });

    if (!typesRes?.value?.list?.length) {
      console.warn("This project does not contain any flat type!");
      return;
    }
    buildingStore.selectedProjectTypes = typesRes.value.list;
    const flatsWithoutRoute: Flat[] = flatsRes?.value?.list;
    asignRoute(flatsWithoutRoute, routeParams);
    buildingStore.selectedFloorFlats = flatsRes?.value?.list;
    flatsList.value = flatsRes?.value?.list || [];
  }, 300);
});

const filteredData = computed(() => {
  const filtered = flatsList.value?.filter((el) => {
    return !el.conf.includes("reserved") && !el.conf.includes("sold");
  });

  return filtered;
});
</script>

<template>
  <div v-if="filteredData?.length" class="special-offers pos-rel">
    <div class="special-offers__items pos-rel">
      <div class="special-offers__title hl-1-plus text-center">
        {{ contentData?.conf?.header?.title }}
      </div>
      <div class="special-offers__cards">
        <Swiper
          ref="carouselRef"
          :grab-cursor="true"
          :watchOverflow="true"
          :slides-per-view="'auto'"
          :space-between="swiperOptions.spaceBetween"
          :breakpoints="swiperOptions.breakpoints"
          :options="swiperOptions"
        >
          <SwiperSlide v-for="(item, index) in filteredData" :key="index">
            <Offer :flatData="item" :filteredData="filteredData" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.special-offers {
  padding-left: 166px;
  padding-right: 167px;
  padding-top: 414px;

  @include maxq(desktop-2k) {
    padding-top: 277px;
    padding-left: 111px;
    padding-right: 111px;
  }
  @include maxq(desktop-lg) {
    padding-top: 207px;
    padding-left: 83px;
    padding-right: 83px;
  }
  @include maxq(desktop) {
    padding: 0px 86px;
    padding-top: 207px;
  }
  @include maxq(tablet) {
    padding-top: 205px;
    padding-left: 80px;
    padding-right: 0px;
  }
  @include maxq(mobile) {
    padding-top: 143px;
    padding-left: 48px;
  }
  @include maxq(mobile-sm) {
    padding-left: 20px;
  }

  &__title {
    color: $black;
    text-transform: uppercase;
    font-size: 112px;
    line-height: 136px;
    margin-bottom: 81px;
    @include weight(400);
    @include maxq(desktop-2k) {
      font-size: 74px;
      line-height: 90px;
      margin-bottom: 55px;
    }
    @include maxq(desktop-lg) {
      margin-bottom: 40px;
      font-size: 56px;
      line-height: 68px;
    }
    @include maxq(mobile) {
      text-align: left;
      font-size: 40px;
      line-height: 48px;
      margin-bottom: 32px;
    }
    @include maxq(mobile-sm) {
      font-size: 32px;
      line-height: 40px;
    }
  }
  &__cards {
    border: 1px solid $brightGray;
    background-color: $white;
    padding: 80px 0;
    @include maxq(desktop-2k) {
      padding: 52px 0;
    }
    @include maxq(desktop-lg) {
      padding: 40px 0;
    }
    @include maxq(tablet) {
      padding-right: 0px;
    }
    .swiper {
      overflow: visible;
      .swiper-slide {
        height: unset;
        width: 29.924242424242426%;
        @include maxq(desktop-lg) {
          width: 30.620155038759687%;
        }
        @include maxq(desktop) {
          width: 28.415300546448087%;
        }
        @include maxq(desktop-sm) {
          width: 52.43362831858407%;
        }
        @include maxq(mobile) {
          width: 75%;
        }
      }
    }
  }
}
</style>
